/**
 * Root Reducer
 * 
 * Purpose: Combines all feature reducers
 * Architecture: Feature-based slices
 */

import { combineReducers } from '@reduxjs/toolkit'
import { authApi } from '@/data/auth/api/auth_api'
import { adminApi } from '@/data/admin/api/admin_api'
import { authSlice } from '@/features/auth/slices/authSlice'
import { dashboardApi } from '@/data/dashboard/api/dashboard_api'
import { adminPortalApi } from '@/data/admin/api/admin_portal_api'
import { uiSlice } from '@/features/common/slices/uiSlice'

export const rootReducer = combineReducers({
  // Auth feature
  auth: authSlice.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [adminApi.reducerPath]: adminApi.reducer,
  [adminPortalApi.reducerPath]: adminPortalApi.reducer,

  // Dashboard feature
  [dashboardApi.reducerPath]: dashboardApi.reducer,

  // Common/UI
  ui: uiSlice.reducer,
})

